import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

export const NeedToShowEmulationModal = ({templateOptions, next}) => cs(
    consumeContext("userLevels"),
    consumeContext("company"),
    consumeContext("session"),
    ["isFromApproval", (_, next) => next(parseUrlQuery(location.search)?.referrer === "approval-requests")],
    ({userLevels, company, session, isFromApproval}) => next(() => (
        userLevels?.userLevel === 5 || isFromApproval || (session?.data?.agent?.idAgent && templateOptions.categories.frontTemplate.type === "subscriber") ? (
                false
            ) : (
                !sessionStorage.getItem("listingId") ||
                company?.prefs?.allowUserLevelAllListingsSearch ||
                !session.emulated
            )
        )
    ),
);